export default __webpack_public_path__ + "static/media/trr-food-handheld-blackbean.fa478465.png";